<template>
<page
  :title='spaceName'
  :with-refresh='false'
  :crumbs="crumbs" >
  <location-form :space-id="spaceId" :location-id="locationId" @input="setLocation" />
</page>
</template>
<script>
import Page from '@/components/layouts/Page.vue'
import LocationForm from '@/components/actions/LocationForm.vue'
export default {
  name: 'LocationPage',
  components: { Page, LocationForm },
  props: {
    spaceId: { required: true },
    locationId: { required: true }
  },
  data () {
    return {
      location: {}
    }
  },
  methods: {
    setLocation (location) {
      this.location = location
    }
  },
  computed: {
    crumbs() {
      let items = [
        { text: 'Home', to: '/' },
        { text: 'Spaces', to: '/settings/spaces/' },
        { text: this.spaceName, to: '/settings/spaces/' + this.spaceId },
        { text: 'Locations', to: '/settings/spaces/' + this.spaceId + '/locations' },
      ]
      if (this.location && this.location.id) {
        items.push({ text: this.location.name })
      }
      return items
    }
  }
}
</script>
